import { useState, useEffect } from 'react'
import { getCachedAuthSession } from 'services/authSessionCache'
import { get } from 'aws-amplify/api'

import { useFeaturesContext } from 'hooks/FeaturesContext'

import WarrantyInfo from 'types/WarrantyInfo'

const useServerlessWarrantyLookup = (serialNumber: string) => {
  const [warranty, setWarranty] = useState<WarrantyInfo | null>(null)
  const [isWarrantyLoaded, setIsWarrantyLoaded] = useState(false)

  const { enabledFeatures } = useFeaturesContext()

  useEffect(() => {
    if (enabledFeatures?.includes('warranty')) {
      (async () => {
        setIsWarrantyLoaded(false)
        const session = await getCachedAuthSession()

        try {
          const res = await get({
            apiName: 'dwaApi',
            path: `/warranties/${serialNumber}`,
            options: {
              headers: { 'Authorization': session?.tokens?.idToken?.toString() || '' }
            }
          }).response

          const data = await res.body.json() as { warranty?: WarrantyInfo } | null
          setWarranty(data?.warranty ?? null)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (_error) {
          setWarranty(null)
        } finally {
          setIsWarrantyLoaded(true)
        }
      })()
    }
  }, [serialNumber, enabledFeatures])

  return {
    warranty,
    isWarrantyLoaded
  }
}

export default useServerlessWarrantyLookup
